import { render, staticRenderFns } from "./JoinInfo.vue?vue&type=template&id=43bc89c0&scoped=true"
import script from "./JoinInfo.vue?vue&type=script&lang=js"
export * from "./JoinInfo.vue?vue&type=script&lang=js"
import style0 from "./JoinInfo.vue?vue&type=style&index=0&id=43bc89c0&prod&lang=scss"
import style1 from "./JoinInfo.vue?vue&type=style&index=1&id=43bc89c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc89c0",
  null
  
)

export default component.exports